import { cn } from '@/lib/utils'
import Image from 'next/image'
import React from 'react'

 const PartnerCard = ({imageUrl,message, customStyle}) => {
   return (
    <div className="max-w-44 w-full h-full  sm:w-44">
      <div
         className={cn(
           "card-premium cursor-pointer overflow-hidden flex-shrink-0 relative h-fit rounded-2xl mx-auto flex flex-col gap-2 p-2",
      
        )}
      >
        <div className="rounded-xl overflow-hidden bg-transparent">
        <Image
              alt={"Best Software Solutions | Nubitsoft "}
              className={cn("h-32   bg-white w-full  object-contain ")}
              width="100"
              height="200"
              // priority
              src={imageUrl}
              />
        </div>
        <div className="text content">
          
          <p className="font-normal text-sm w-full text-center text-slate-200 relative z-10 py-1">
            {message}
          </p>
        </div>
      </div>
    </div>
  )
}
export default PartnerCard
